import React from 'react';
import InnerHTML from '../../../../../generic/Utils/InnerHtml';

const EventDetails = ({ label, timeAndModeDetails, description }) => {
  return (
    <div className='border-top mt-3 pt-4 d-flex flex-column justify-content-center align-items-start cui-flex-gap-18'>
      <div className="font-weight-bold">{ label }</div>
      <InnerHTML content={ timeAndModeDetails } />
      <InnerHTML content={ description } containerClass="chr-rich-text-editor py-3 fr-view cui-custom-content" />
    </div>
  )
};

export default EventDetails;